export default __webpack_public_path__ + "static/media/code-solid.b470fb0a.svg";